
<label class="col-xs-4 p-0" *ngIf="title">{{title}}</label>
<div class="col-xs-12 p-0 pb-2">
  <div data-testid="language-string-chip" class="badge m-2 ml-0" *ngFor="let value of list;let valueIndex = index;">
    <language-view [languageStringObj]="value"></language-view><i data-testid="language-string-chip-remove" class="fa fa-trash-o pointer pl-2" (click)="removeToRowLanguagesStringValues(valueIndex)"></i>
  </div>
</div>
<language-string-auto-complete [tags]="tags" (onSelection)="addToRowLanguageString($event)" [required]="required && !list.length" [pattern]="'^#$'"></language-string-auto-complete>
